export default __webpack_public_path__ + "static/media/025-walrus.497da37c.svg";